// @flow

import * as React from 'react';
import GifIcon from 'app/common/react/components/DeprecatedPinRep/PinTypeIdentifier/GifIcon';
import i18n from 'app/common/lib/i18n';
import RatingStars from 'app/packages/recipe-star-components/RatingStars';
import StoryPinIcon from 'app/common/react/components/DeprecatedPinRep/PinTypeIdentifier/StoryPinIcon';
import { Box, Icon, Text } from 'gestalt';

const COLLAGE_ICON_PATH = {
  __path:
    'M6 5h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm8 0h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm0 8h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1z',
};

type PinIcon = 'arrow-up-right' | 'play' | 'gif' | 'tag' | 'star' | 'story-pin' | 'collage';

type Props = {
  icon?: PinIcon,
  max_rating?: string,
  pinId?: string,
  rating?: string,
  text?: string,
};

const getLabel = (icon: PinIcon): string => {
  switch (icon) {
    case 'arrow-up-right':
      return i18n._('Promoted Pin', 'Icon indicating this Pin is promoted');
    case 'play':
      return i18n._('Video Pin', 'Icon indicating this Pin is a video');
    case 'gif':
      return i18n._('GIF Pin', 'Icon indicating this Pin is a GIF');
    case 'tag':
      return i18n._('Product Pin', 'Icon indicating this Pin is a product');
    case 'star':
      return i18n._('Recipe Pin', 'Icon indicating this Pin is a recipe');
    case 'story-pin':
      return i18n._('Story Pin', 'Icon indicating this Pin is a story');
    case 'collage':
      return i18n._('Collage Pin', 'Icon indicating this Pin is a collage');
    default:
      // Should never be hit due to restrictions on icon
      return '';
  }
};
export default function PinTypeIdentifier({ max_rating, icon, text, rating, pinId }: Props) {
  let iconElement;
  if (icon) {
    switch (icon) {
      case 'star':
        iconElement = <RatingStars rating={rating || ''} max_rating={max_rating} width={10} />;
        break;
      case 'gif':
        iconElement = <GifIcon height={10} color="#333" />;
        break;
      case 'story-pin':
        iconElement = <StoryPinIcon pinId={pinId} />;
        break;
      default:
        const iconProps = {
          accessibilityLabel: getLabel(icon),
          color: 'darkGray',
          size: 10,
          inline: true,
        };
        iconElement = (
          <Box display="flex" alignItems="center" marginRight={1}>
            {icon === 'collage' ? (
              <Icon dangerouslySetSvgPath={COLLAGE_ICON_PATH} {...iconProps} />
            ) : (
              <Icon icon={icon} {...iconProps} />
            )}
          </Box>
        );
    }
  }

  return (
    <Box display="flex" alignItems="center">
      {iconElement}
      {text && (
        <Box marginLeft={1}>
          <Text inline size="sm">
            {text.trim().substring(0, 25)}
          </Text>
        </Box>
      )}
    </Box>
  );
}
